import { inject, Injectable } from '@angular/core';
import { MultiselectItem } from '@ui/aos-lib';
import { map, Observable } from 'rxjs';
import { DevicesDataService } from 'src/app/services/data/devices-data/devices-data.service';
import { DevicesApiService } from './devices-api.service';
import { DeviceFirmwareVersionTypeFilter } from '../components/devices.models';
import { FilterModel } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import {
  MAIN_BOARD_FW,
  POWER_SUPPLY_BOARD_FW,
  SLOT_J_FW,
  SLOT_T_FW
} from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';

@Injectable({ providedIn: 'root' })
export class DeviceFilterListingService {
  readonly devices = inject(DevicesDataService);
  readonly devicesApiService = inject(DevicesApiService);
  readonly FW_BY_TYPE: Record<DeviceFirmwareVersionTypeFilter, FilterModel> = {
    [DeviceFirmwareVersionTypeFilter.MotherBoardFirmware]: MAIN_BOARD_FW,
    [DeviceFirmwareVersionTypeFilter.PowerSupplyFirmware]: POWER_SUPPLY_BOARD_FW,
    [DeviceFirmwareVersionTypeFilter.J_BoardFirmware]: SLOT_J_FW,
    [DeviceFirmwareVersionTypeFilter.T_BoardFirmware]: SLOT_T_FW
  };

  getDeviceFwVersionsFilter(deviceType: DeviceFirmwareVersionTypeFilter): Observable<FilterModel> {
    return this.devicesApiService.getDeviceFirmwareVersions(deviceType).pipe(
      map((fwVersions: string[]) => {
        const fwVersionItems: MultiselectItem[] = fwVersions.map(fwVersion => ({
          text: fwVersion,
          value: fwVersion,
          isDisabled: false
        }));

        return {
          ...this.FW_BY_TYPE[deviceType],
          items: fwVersionItems,
          selected: fwVersionItems
        };
      })
    );
  }
}
